import { createFileRoute } from "@tanstack/react-router"
import { ApplyVerifyEmail } from "@/app"

export const Route = createFileRoute("/(public)/auth/verify/apply")({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useSearch()

  return <ApplyVerifyEmail params={params as Record<string, string>} />
}
